






import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import Liaison from '@/views/AiiTasks/liaison.vue'
import TaskApi from '@/api/task'
import { TOKEN } from '@/store/mutation-types'

let body = document.body || document.documentElement
const initContent = {
	title: '',
	itemList: [
		{
			title: '',
			content: '',
		},
	],
}

@Component({
	name: 'liaisonPreview',
	components: {
		Liaison,
	},
})
export default class liaisonPreview extends Vue {
	private liaison: any = {}

	private get notPreview(): boolean {
		return !(
			this.$route.query.isPreview ||
			(this.$route.params.orderId && this.$route.params.token)
		)
	}

	private get isH5(): boolean {
		return !!(this.$route.params.orderId && this.$route.params.token)
	}

	private async created() {
		let res: any = {}
		if (this.isH5) {
			const orderId = this.$route.params.orderId
			const token = this.$route.params.token
			body.style.width = '375px'
			body.style.minWidth = 'auto'
			this.$ss.set(TOKEN, token)
			res = await TaskApi.getH5TaskManual({
				orderId: orderId,
				token: token,
			})
		} else {
			res = await TaskApi.getTaskManual()
		}
		this.liaison = res.data
	}
}
